import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, EventEmitter, inject, Input, OnInit, Output } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { CustomformComponentDef } from '@df/catalog-ui/customform/customform.component.def';
import { Status } from '@df/core/status';
import { TimeoutService } from '@df/ng/timeout.service';
import { ModalRef } from '@df/ui/modal/modal-ref';
import { TranslationModule } from '@df/ui/translation/translation.module';
import { InputWrapBodyDirective } from 'projects/app-default/src/app/ui/form/input-wrap-body.directive';
import { InputWrapComponent } from 'projects/app-default/src/app/ui/form/input-wrap.component';
import { ResultComponent } from 'projects/app-default/src/app/ui/resut/result.component';
import { ProductPosModalComponent } from '../product-pos-modal.component';

@Component({
    selector: 'product-pos-modal-form',
    templateUrl: './product-pos-modal-form.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: true,
    imports: [TranslationModule, CommonModule, FormsModule, ResultComponent, InputWrapComponent, InputWrapBodyDirective]
})
export class ProductPosModalFormComponent extends CustomformComponentDef<{}> implements OnInit {
    @Input({ required: true }) buttonClick!: EventEmitter<void>;
    @Input({ required: true }) sku!: string;
    @Output() statusChange = new EventEmitter<Status>();
    private modalRef = inject(ModalRef<ProductPosModalComponent>);
    private timeoutService = inject(TimeoutService);

    override dataReset(): void {
        super.dataReset();
        this.assignCustomerData();
    }

    override ngOnInit() {
        super.ngOnInit();
        this.statusChange.emit(this.status);
        this.buttonClick.subscribe(() => {
            this.submit(() => {
                this.timeoutService.setTimeout(() => {
                    this.modalRef.close();
                }, 1000);
            });
        });
    }

    private assignCustomerData(): void {
        const customerData = this.app.customer.model.data;
        this.fields?.map(el => {
            switch (el.label) {
                case 'email':
                    this.data[el.cid] = customerData.email;
                    break;
                case 'tradeId':
                    this.data[el.cid] = customerData?.bc_customer_id;
                    break;
                case 'sku':
                    this.data[el.cid] = this.sku;
                    break;
                default:
                    console.warn(`Unhandled label: ${el.label}`);
            }
        });
    }

    override reset(): void {
        this.detectChanges();
        super.reset();
    }
}
